module.exports = __webpack_public_path__ + "static/livecoin-bafc3fe408fbf4886e38d67b2647885d.png";